import React from 'react';
export function AnnouncementBar() {
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-blue px-3 text-white shadow-sm" data-id="element-18" data-mp="2tgqpao3xs0lk">
      <p className="truncate text-[10px] font-extrabold tracking-[0.08em] sm:text-[11px]" data-id="element-19" data-mp="ju3lovdqfez5">
        🎨 Il curricolo artistico completo per la scuola italiana
      </p>
    </aside>;
}